// onix codelist 26. thema subject categories start with a letter and go in 93, qualifiers start
// with a digit naming their type and each type has its own scheme. sending a qualifier as 93 makes
// it look like a subject category, and as the first 93 a recipient takes it as the main subject
const themaQualifierSchemes = {
	1: "94", // place
	2: "95", // language
	3: "96", // time period
	4: "97", // educational purpose
	5: "98", // interest age and special interest
	6: "99", // style
};

const themaSubjectCategoryScheme = "93";

// the main code is only flagged when it is one of the subject categories, an article can override
// its codes while still inheriting a main code from the work
export default function getThemaSubjects(themaCodes = [], mainThemaCode = null) {
	const subjects = themaCodes
		.filter(Boolean)
		.map((code) => ({ code, scheme: themaQualifierSchemes[code[0]] || themaSubjectCategoryScheme }))
		.map((subject) =>
			subject.code === mainThemaCode && subject.scheme === themaSubjectCategoryScheme
				? { ...subject, main: true }
				: subject,
		);

	return [
		...subjects.filter(({ main }) => main),
		...subjects.filter(({ scheme, main }) => !main && scheme === themaSubjectCategoryScheme),
		...subjects.filter(({ scheme }) => scheme !== themaSubjectCategoryScheme),
	];
}
